export const aciCloseAlt = {
    iconName: 'close-alt',
    svgDef: {
        attr: { fill: 'none', viewBox: '0 0 16 16' },
        path: {
            attr: {
                'clip-rule': 'evenodd',
                d: 'M9.98 3.066L8.095 4.952 6.209 3.066a1.778 1.778 0 00-2.514 0l-.629.629a1.778 1.778 0 000 2.514l1.886 1.886L3.066 9.98a1.778 1.778 0 000 2.514l.629.629c.694.694 1.82.694 2.514 0l1.886-1.886 1.885 1.886c.694.694 1.82.694 2.514 0l.629-.628a1.778 1.778 0 000-2.515l-1.886-1.885 1.886-1.886a1.778 1.778 0 000-2.514l-.629-.629a1.778 1.778 0 00-2.514 0z',
                stroke: 'currentColor',
                'stroke-linecap': 'round',
                'stroke-linejoin': 'round',
            },
        },
    },
};
